import React from "react";
import { ArrowRight } from "lucide-react";

export default function WelcomeCard({ icon: Icon, title, description, cta, onClick, index = 0 }) {
  return (
    <div
      className="bg-card border border-border rounded-none shadow-sm hover:shadow-md hover:border-[#F18D50] transition-all flex flex-col p-6"
    >
      <div className="w-11 h-11 flex items-center justify-center bg-primary/[0.08] mb-4">
        <Icon className="w-6 h-6 text-[#F18D50]" />
      </div>
      <h3 className="text-lg font-bold mb-2 leading-snug">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed flex-1 mb-5">{description}</p>
      <button
        onClick={onClick}
        className="inline-flex items-center gap-2 text-sm font-semibold text-[#F18D50] hover:gap-3 transition-all self-start"
      >
        {cta} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}